import {
    PLAYLIST
} from "../../actions";
import http from "../../../service"

import {
    playlist,
} from "../../../endPoints";

export const getPlaylist = (program_type_id, content_id) => {
    return async dispatch => {
        const data = await http.getWebApi(playlist + `/${program_type_id}` + `/${content_id}`);
        dispatch({type: PLAYLIST, payload: data})
    };
};